import { type Common } from './common.js';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async findUrlById(id: string): Promise<{ url: string }> {
    const url = this.common.constructPath(`/patient-advisory-documents/${id}/url`);

    return await this.common.getJSON(url);
  }
}
